import React from 'react';
import * as ReactDOM from 'react-dom';

export default class LoadingPanel extends React.Component {
  render() {
    const loadingPanel = (
      <div className="k-loading-mask">
        <span className="k-loading-text">Loading</span>
        <div className="k-loading-image"></div>
        <div className="k-loading-color"></div>
      </div>
    );

    // Получаем ref на нужный контейнер
    const { container } = this.props;
    return container ? ReactDOM.createPortal(loadingPanel, container) : loadingPanel;
  }
}